import { cn } from '@/lib/utils';

type FormMessageTone = 'error' | 'success' | 'info';

interface FormMessageProps {
  tone: FormMessageTone;
  message: string;
}

const toneClass: Record<FormMessageTone, string> = {
  error: 'bg-red-50 text-red-600',
  success: 'bg-green-50 text-green-700',
  info: 'bg-blue-50 text-blue-700',
};

export default function FormMessage({ tone, message }: FormMessageProps) {
  return <div className={cn('px-4 py-3 rounded-xl text-[0.875rem]', toneClass[tone])}>{message}</div>;
}
